import React, { Component, Fragment } from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';
import jsLang from '../lib/jslang';

export default class SubmissionFigures extends Component {
    constructor(props) {
        super(props);

        const timePeriods = [
            '7days',
            '30days',
            'currentQuarter',
            'previousQuarter',
            'allTime',
        ];

        this.state = {
            timePeriods,
            selectedTimePeriod: timePeriods[0],
        };

        this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
    }

    handleDateRangeChange(event) {
        this.setState({
            selectedTimePeriod: event.target.value,
        });
    }

    render() {
        const {
            selectedTimePeriod,
            timePeriods,
        } = this.state;

        const {
            data,
        } = this.props;

        return (
            <Fragment>
                <form className="m-b-lg">
                    <div className="form__group">
                        <label htmlFor="timePeriod" className="inline-block bold m-r-xs">{ jsLang.get('dashboard.dateRange') }</label>

                        <div className="inline-block select width-auto">
                            <select
                                className="form__control"
                                name="timePeriod"
                                id="timePeriod"
                                value={ selectedTimePeriod }
                                onChange={ this.handleDateRangeChange }
                            >
                                { timePeriods.map(timePeriod => (
                                    <option key={ timePeriod } value={ timePeriod }>{ jsLang.get(`dashboard.dateRanges.${timePeriod}`) }</option>
                                )) }
                            </select>
                        </div>
                    </div>
                </form>

                <div className="grid grid--gutter-xs">
                    <div className="grid__col grid__col-12">
                        <div className="grid grid--gutter-xs grid--h-gutter-none cards-same-height">
                            <dl className="grid__col grid__col-12 grid__col-md-4">
                                <div className="card br-a-none bs-a-none b-r-none-md">
                                    <dt className="h4">{ jsLang.get('dashboard.leadsAdded.title') }</dt>
                                    <dd id="leads-added-figure" className="font-size-xl colour-primary bold">
                                        { data[selectedTimePeriod].leadsAdded }
                                    </dd>
                                </div>
                            </dl>

                            <dl className="grid__col grid__col-12 grid__col-md-4">
                                <div className="card br-a-none bs-a-none b-r-none-md">
                                    <dt className="h4">{ jsLang.get('dashboard.jobsQualified.title') }</dt>
                                    <dd id="installs-qualified-figure" className="font-size-xl colour-primary bold">
                                        { data[selectedTimePeriod].installsQualified }
                                    </dd>
                                </div>
                            </dl>

                            <dl className="grid__col grid__col-12 grid__col-md-4">
                                <div className="card br-a-none bs-a-none">
                                    <dt className="h4">{ jsLang.get('dashboard.jobsInstalled.title') }</dt>
                                    <dd id="installs-completed-figure" className="font-size-xl colour-primary bold">
                                        { data[selectedTimePeriod].installsCompleted }
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

SubmissionFigures.propTypes = {
    data: PropTypes.objectOf(PropTypes.object).isRequired,
};

const element = document.getElementById('submission-figures');

if (element) {
    const props = Object.assign({}, element.dataset);
    const data = JSON.parse(decodeURIComponent(props.data));
    render(<SubmissionFigures { ...props } data={ data } />, element);
}
